import { useNavigate } from "react-router-dom";
import StatCard from "components/card/stat-card";
import { stats } from "content/stats";

const AboutConclase = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-white px-6 sm:px-10 xl:px-20 py-12 xl:py-16 flex flex-col gap-10">
      {/* Top row: heading + button */}
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-6">
        <div data-aos="fade-up" className="flex flex-col gap-4 max-w-[680px]">
          <h2 className="text-[32px] xl:text-[40px] font-black text-blue-100 leading-tight">
            About{" "}
            <span className="text-blue-400">Conclase</span>
          </h2>
          <p className="text-dark-100 xl:text-lg leading-relaxed">
            Conclase is a technology consulting company helping organization
            build, deploy, and scale high-performing technology teams — From
            talent recruitment to project delivery and corporate training, we
            help organization solve real technology challenges with the right
            people and capabilities.
          </p>
        </div>

        <div data-aos="fade-up" data-aos-delay="150" className="shrink-0">
          <button
            onClick={() => navigate("/about")}
            className="px-6 py-3 bg-yellow-100 text-blue-100 font-semibold rounded-full hover:bg-yellow-200 transition-all whitespace-nowrap"
          >
            Learn more About us
          </button>
        </div>
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {stats.map((stat, index) => (
          <div
            key={stat.label}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
          >
            <StatCard {...stat} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutConclase;
